var render = function render(){var _vm=this,_c=_vm._self._c;return _c('shared-invoice-list-table',{attrs:{"internal-only":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }